import myTaskActions from '../../../actions/myTaskActions';
import taskTableColumns, {
  taskTableLeftFixedColumns,
  taskTableDataSortingByColumns,
  taskTableSummaries,
  TaskTableCellComponent,
  taskSelectionOperations,
} from './taskTableColumns';
import generateEntityTable from '../../../hocs/generateEntityTable';

const taskEditorRoutePath = '/my-task-edition';

const MyTasksTable = generateEntityTable({
  entityPluralString: 'tasks',
  entityActions: myTaskActions,
  editorRoutePath: taskEditorRoutePath,
  columns: taskTableColumns,
  leftFixedColumns: taskTableLeftFixedColumns,
  dataSortingByColumns: taskTableDataSortingByColumns,
  cellComponent: TaskTableCellComponent,
  selectionOperations: taskSelectionOperations,
  summaries: taskTableSummaries,
  enableSelection: true,
});

export default MyTasksTable;
